import { Id } from "@/fx/Id";
import { SYS } from "../../system";
import { testDefaults } from "./_common/test-defaults";
import { commandProvider, updateCommandTestDescriptor } from "../_common/command-descriptors";
import { LEGACY_CreateDraftClaim_V1 } from "../Claims/legacy/LEGACY_CreateDraftClaim_V1";
import { CLM } from "../../claims";
import { defaultCommandValidator } from "../_common/validators";

export type UpdateResource_TestingTags = {
  id:           Id;
  testingTags?: SYS.TestingTag[];
};
export type RawUpdateResource_TestingTags = Omit<UpdateResource_TestingTags, "id" | "testingTags"> & {
  id:           bigint;
  testingTags?: string;
};
export const toRawUpdateResource_TestingTags = (_: UpdateResource_TestingTags): RawUpdateResource_TestingTags => ({
  ..._,
  id:          _.id.asInt,
  testingTags: _.testingTags?.map((_) => _.identifier).join(","),
});
export const fromRawUpdateResource_TestingTags = (_: RawUpdateResource_TestingTags): UpdateResource_TestingTags => ({
  ..._,
  id:          Id.from(_.id) as Id,
  testingTags: _.testingTags?.split(",").map((_) => SYS.testingTag(_)),
});

const withNoTagsCommand            =                              ({ claimId }: { claimId: CLM.ClaimId }) => withTagsCommand({ claimId       });
const withTagsCommand_havingTagsAs = (tags?: SYS.TestingTag[]) => ({ claimId }: { claimId: CLM.ClaimId }) => withTagsCommand({ claimId, tags });

const withTagsCommand = ({ claimId, tags }: { claimId: CLM.ClaimId, tags?: SYS.TestingTag[] }) => {
  return {
    id:          claimId,
    testingTags: tags,
  };
}

export const UpdateResource_TestingTags = (() => {
  const descriptor = {
    commandName:    "UpdateResource_TestingTags",
    commandToRaw:   toRawUpdateResource_TestingTags,
    commandFromRaw: fromRawUpdateResource_TestingTags,
  };

  const generated = {
    default:    commandProvider(descriptor)({ command: withNoTagsCommand }),
    withNoTags: commandProvider(descriptor)({ command: withNoTagsCommand }),
    withTags:   commandProvider(descriptor)({ command: withTagsCommand   }),

    withTagsAs: (tags?: SYS.TestingTag[]) => commandProvider(descriptor)({ command: withTagsCommand_havingTagsAs(tags) }),
  };

  const tests = {
    updateResource_testingTags: updateCommandTestDescriptor({
      createCommandProvider:    LEGACY_CreateDraftClaim_V1.generated.random,
      prepCommandProviders:     [],
      commandUnderTestProvider: generated.default,
      validator: (command, ctx) => {
        return defaultCommandValidator(command, (ctx as any).data.claim);
      }
    }),
  };

  return { descriptor, generated, testDefaults, tests };
})();
